import * as React from 'react'
import { Search, X } from 'lucide-react'
import { Button } from '@/shared/components/ui/button'
import { Input } from '@/shared/components/ui/input'
import { cn } from '@/shared/lib/utils'

interface SearchInputProps
  extends Omit<React.ComponentProps<'input'>, 'type' | 'onChange'> {
  value: string
  onChange: (value: string) => void
  /** Icon size in px. Defaults to 14. */
  iconSize?: number
}

function SearchInput({
  value,
  onChange,
  iconSize = 14,
  className,
  ...props
}: SearchInputProps) {
  const inputRef = React.useRef<HTMLInputElement>(null)

  return (
    <div className="relative">
      <Search
        style={{ width: iconSize, height: iconSize }}
        className="pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2 text-[var(--ink-3)]"
      />
      <Input
        ref={inputRef}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={cn('pl-8', value && 'pr-7', className)}
        {...props}
      />
      {value && (
        <Button
          type="button"
          variant="ghost"
          onClick={() => {
            onChange('')
            inputRef.current?.focus()
          }}
          tabIndex={-1}
          aria-label="Clear search"
          className="absolute right-2 top-1/2 flex h-4 w-4 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full border-none bg-[var(--ink-3)]/15 p-0 text-[var(--ink-3)] shadow-none transition-colors hover:bg-[var(--ink-3)]/25 hover:text-[var(--ink)]"
        >
          <X className="h-2.5 w-2.5" />
        </Button>
      )}
    </div>
  )
}

export { SearchInput }
